import { createSelector } from 'reselect';

import selectAuth from './selectAuth';

const selectAuthPrevUser = createSelector(selectAuth, (auth) => auth.prevUser);

export default selectAuthPrevUser;
